// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2w3Ej","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2FyUN"};